<template>
  <div>
    <div class="upload-button">
      <div>
        <button class="btn btn-default btn-lg btn-link" @click="showHide" style="font-size:36px;">
          <span class="fa fa-folder text-info" v-if="!show"></span>
           <span class="fa fa-folder-open text-info" v-if="show"></span>
        </button>
        <span class="badge badge-notify">{{ uploadedFiles.length }}</span>
      </div>
    </div>

    <div class="card mb-3" v-if="show">
      <div class="card-header">
        <i class="fa fa-upload"></i> 
        <strong>Upload Files</strong> 

        <div class="float-right">

        </div>
      </div>
      <div class="card-body" v-if="compMode !== null">
        <div class="row" v-if="compMode !== CRUDMODE.READ">
          <div class="form-group col-md-12">
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
              <div class="dropbox">
                <input type="file"  multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="input-file">
                <p v-if="isInitial || isSuccess">
                  Drag your file(s) here to begin<br> or click to browse
                </p>
                <p v-if="isSaving">
                  Uploading {{ fileCount }} files...
                </p>
              </div>
            </form>
          </div>
        </div>

        <div class="row" v-if="isSuccess || isFailed">
          <div class="form-group col-md-12">
            <div v-if="isSuccess" class="alert alert-success" role="alert">
              Uploaded file(s) successfully. - 
              <a href="javascript:void(0)" @click="reset()">Dismiss</a>
            </div>
            <div v-if="isFailed" class="alert alert-danger" role="alert">
              Uploaded failed: {{ uploadError }}
              <a href="javascript:void(0)" @click="reset()">Dismiss</a>
            </div>
          </div>
        </div>

        <!-- Progress Bar>
        <div class="progress">
        <div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%;">
        <span class="sr-only">60% Complete</span>
        </div>
        </div -->
        
        <!-- Upload Finished -->
        <div class="row" v-if="uploadedFiles.length > 0">
          <div class="form-group col-md-12">
            <div class="list-group" v-for="(file, index) in uploadedFiles" :key="file.fileName"> 
              <a href="#" class="list-group-item list-group-item-success">

                {{ file.name }}

                <div class="btn-group pull-right" role="group" aria-label="Actions">
                  <button type="button" class="btn btn-primary" v-on:click.stop="seeFile(index)"> <span class="fa fa-lg fa-download"></span> </button>
                  <button type="button" class="btn btn-danger" v-if="compMode !== CRUDMODE.READ" v-on:click.stop="deleteFile(index)"> <span class="fa fa-lg fa-trash"></span></button>
                </div>

              </a>
            </div>
          </div>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
  import Enum, {fileType} from '../enum'
  import store from '../../store'
  import {mapActions, mapState} from 'vuex'
  
  import ServiceFactory from '../service-clients/serviceClientFactory'
  import {TempFilesServiceClient, FilesServiceClient} from '../service-clients/service-clients'

  // Based upon this: https://scotch.io/tutorials/how-to-handle-file-uploads-in-vue-2
  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    name: 'FileUploader',
    props: {
      entite: {
        type: String,
        required: true,
      },
      compMode: {
        default: Enum.Mode.CREATE,
      },
    },
    data() {
      return {
        CRUDMODE: Enum.Mode,
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'files',
        show: false,
        fileCount: 0,
      }
    },
    computed: {
      uploadedFiles: () => store.state.files,
      isInitial() {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED
      },
    },
    methods: {
      ...mapActions(['uploadFiles', 'fetchFiles', 'deleteFile']),
      seeFile: function(index) {
        let file = this.uploadedFiles[index]
        let factory = FilesServiceClient

        if (file.infos.host.indexOf('/temp') > -1) factory = TempFilesServiceClient
  
        let service = ServiceFactory.create(factory)
        let self = this

        service
          .download(
            file.infos.changed,
            file.infos.fileName,
            file.infos.relativePath,
            file.infos.host,
            file.infos.absoluteUri,
            file.infos.contentType,
            file.infos.contentLength
          )
          .then(res => {
            window.open(res)
          })
          .catch(err => {
            //this.getErrorMessage(err)
          })
      },
      showHide: function() {
        this.show = !this.show
      },
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.uploadError = null
      },
      save(formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING
        let self = this
  
        this.uploadFiles({formData: formData, entite: this.entite})
          .then(this.wait(500))
          .then(x => {
            self.currentStatus = STATUS_SUCCESS

            setTimeout(function() {
              self.reset()
            }, 5000)
          })
          .catch(err => {
            this.uploadError = err.status + ' - ' + err.statusText
            this.currentStatus = STATUS_FAILED
          })
      },
      filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData()

        if (!fileList.length) return

        // append the files to FormData
        Array.from(Array(fileList.length).keys()).map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

        // save it
        this.save(formData)
      },
  
      // TODO: Used just for test purposes, remove after
      wait: function(ms) {
        return x => {
          return new Promise(resolve => setTimeout(() => resolve(x), ms))
        }
      },
    },
    mounted() {
      this.reset()

      if (this.compMode != null && this.compMode != Enum.Mode.CREATE && this.compMode != Enum.Mode.COPY) {
        this.fetchFiles({entite: this.entite, id: this.$route.params.id, fileType: Enum.FileType.FILE})
      }
    },
  }
</script>

<style lang="scss">
  .upload-button {
    position: absolute;
    z-index: 999;
    right: 0;
    top: 60px;
  }
  .badge-notify{
    background: #ccc;
    position:relative;
    top: -17px;
    left: -25px;
    font-size: 14px;
  }
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>


// WEBPACK FOOTER //
// src/shared/components/FileUploader.vue